<template>
  <div>
    <div class="supplier-title">
      <span>供应商应用系统使用帮助</span>
    </div>
    <div class="supplier-card">
      <el-row :gutter="5">
        <el-col :span="6">
          <el-card shadow="hover" class="cgdd">
              <div slot="header">采购订单</div>
              <div>
                <ul style="line-height:3">
                  <li>采购订单页面 为甲方下单数据展示页</li>
                  <li>包含采购订单及订单明细两部分数据</li>
                  <li>点击采购订单 下方会显示该笔订单明细</li>
                  <li>供应商确保可以按预期时间发货情况下 可以进行接单操作</li>
                  <li>逾期未进行接单的订单 会被作废处理</li>
                  <li>页面支持按发货状态及下单事件进行数据检索</li>
                </ul>
              </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="fh">
              <div slot="header">供应商发货</div>
              <div>
                <ul style="line-height:3">
                  <li>供货商发货页面为采购订单的二级页面</li>
                  <li>已接单的订单在采购订单页面进行发货</li>
                  <li>点击发货按钮会跳转至供货商发货页面</li>
                  <li>跳转后点击获取订单会获取发货明细</li>
                  <li>发货数量默认为按下单数量进行发货</li>
                  <li>供应商可根据实际情况修改发货数量，支持多批次发货</li>
                  <li>确认发货信息无误，可点击提交按钮，提交发货信息</li>
                </ul>
              </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="fhlb">
              <div slot="header">供应商发货列表</div>
              <div>
                <ul style="line-height:3">
                  <li>供货商发货列表页面展示内容为发货记录及发货明细</li>
                  <li>用户可在该页面进行发货记录的审核</li>
                </ul>
              </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover" class="mx">
              <div slot="header">供应商明细</div>
              <div>
                <ul style="line-height:3">
                  <li>供货商明细页面为用户信息维护页</li>
                  <li>可维护供货商联系人及发票信息等基本信息</li>
                </ul>
              </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "../../style/homepage/supplier.scss";
</style>


// WEBPACK FOOTER //
// src/components/homepage/supplier.vue